<template>
  <div class="form-item ve-upload" v-show="item.visible">
	<el-tooltip class="item" effect="dark" placement="top-start" v-if="item.description">
      <div slot="content">
        {{item.description}}
      </div>
      <img class="form-tooltip" :src="require('@/assets/question.png')"/>
    </el-tooltip>
    <el-form-item :rules="rules" :prop="item.prop">
      <div @click="uploadFile">
        <el-upload action=""
                   :class="{ hiddenUpload:  fileList.length }"
                   class="pdf-file"
                   v-if="item.contentType === 'media/file'"
                   :file-list="fileList"
                   :on-remove="handleRemoveFile"
                   :before-upload="beforeUpload">
          <img src="@/assets/file_active.png"  class="ve-upload-icon" v-if="fileList.length"/>
          <img src="@/assets/file_upload.png"  class="ve-upload-icon" v-else/>
          <div class="el-upload__text">
            <em>{{$t('app.upload_pdf')}}</em>
          </div>
        </el-upload>
      </div>

      <div @click="uploadImage">
        <el-upload action=""
                   :class="{ hiddenUpload: imageBase64 }"
                   v-if="item.contentType === 'media/image'"
                   :file-list="imgFileList"
                   :on-remove="handleRemove"
                   :before-upload="beforeUpload"
                   list-type="picture-card">
          <img src="@/assets/image_upload.png"  class="ve-upload-icon"/>
          <div class="el-upload__text">
            <em>{{$t('app.upload_img')}}</em>
          </div>
        </el-upload>
        <!--<img :src="imgFileList[0].url" v-if="item.contentType === 'media/image' && imgFileList.length" style="width: 80vw"/>-->
      </div>

      <div @click="uploadVideo" style="position: relative">
        <video style="width: 100%;height: 70vw;background-color: #4A4A4A"
               controls='controls'
               v-if="item.contentType.toLowerCase() === 'media/video' && videoFileList.length"
               :src="videoFileList[0].url">
        </video>
        <el-upload action=""
                   :class="{ hiddenUpload:  videoBase64 }"
                   v-if="item.contentType.toLowerCase() === 'media/video'"
                   :file-list="videoFileList"
                   :on-remove="handleRemoveVideo"
                   :before-upload="beforeUpload">
          <img src="@/assets/video_active.png"  class="ve-upload-icon" v-if="videoFileList.length"/>
          <img src="@/assets/video_upload.png"  class="ve-upload-icon" v-else/>
          <div class="el-upload__text">
            <em>{{$t('app.upload_video')}}</em>
          </div>
        </el-upload>
      </div>

      <span style="" v-if="!itemdata" class="prompt">{{item.prompt || ''}}</span>
    </el-form-item>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
	import utils from '@/utils'
	import language from '@/lang'
	import callApp from '@/services/sdk'

	export default {
		name: 'file-widget',
		props: {
			editable: { type: Boolean },
			value: [String, Object],
			item: Object,
      deep: Number
		},
		data() {
			return {
				rules: utils.generateFormRule(this.item),
        fileName: '',
				fileList: [],
				imgFileList: [],
				videoFileList: [],
				imageBase64: '',
				videoBase64: ''
			}
		},
		mounted() {
			if (this.itemdata != '') {
				var keys = ["filehash",
					"filelocation",
					"filename",
					"filesize",
					"filetype"]
				var empty = true 
				keys.forEach(key=> {
					if (this.itemdata[key] != undefined && typeof(this.itemdata[key]) == 'string' && this.itemdata[key].length > 0) {
						empty = false
					}
				})
				if (empty && this.itemdata && this.itemdata['filelocation'] != undefined) {
					this.itemdata = {}
				}	
			}
		},
		methods: {
			spliceUrl(location) {
				const domain = this.$store.state.domain
				const token = this.$store.state.token
        return location ? domain + location + '?token' + token : location
			},
			failUpload() {
				callApp('delCacheFile', {}, 'cbDelCacheFile')
			},
			successUpload() {
				callApp('addCacheFile', { uuid: this.item.uuid }, 'cbAddCacheFile')
			},
			handleRemoveFile() {
				this.fileName = ''
				this.fileList = []
				this.itemdata = ''
      },
			handleRemoveVideo() {
				this.fileName = ''
				this.videoFileList = []
				this.itemdata = ''
				this.videoBase64 = ''
			},
			handleRemove() {
				this.fileName = ''
				this.imgFileList = []
				this.itemdata = {
					"filehash": "",
					"filelocation": "",
					"filename": "",
					"filesize": "",
					"filetype": ""
				}
				this.imageBase64 = ''
			},
			beforeUpload() {
				return false
			},
			uploadFile(e) {
				if (e.target.className !== 'el-upload__input') return
				callApp('getFile', {
					type: 'dataSource.file.file',
					data: {
						max: this.item.max,
						type: this.item.acceptedFileType || []
					}
				}, 'cbGetFile')
					.then(data => {
						this.fileList = []
						this.itemdata = {
							"filehash": "",
							"filelocation": "",
							"filename": "",
							"filesize": "",
							"filetype": ""
						}
						this.$nextTick(() => {
							if (data.files) {
								this.itemdata = { ...data.files[0] }
								this.fileName = data.files[0].filename
								this.fileList = [{url: this.spliceUrl(data.files[0].filelocation), name: this.fileName}]
							}
						})
					})
				e.preventDefault()
			},
			localized(key){
				if (this.item) {
					console.log(this.item)
					return language.localize(this.$store.state,this.item.name, key, this.item[key])
				}
				return ""
			},
			uploadVideo(e) {
				if (e.target.className !== 'el-upload__input') return
				this.itemdata = {
					"filehash": "",
					"filelocation": "",
					"filename": "",
					"filesize": "",
					"filetype": ""
				}
				callApp('getVideo', {
					type: 'dataSource.file.video',
					data: {
						max: this.item.max,
						type: this.item.acceptedFileType || []
					}
				}, 'cbGetVideo')
					.then(data => {
						this.videoFileList = []
						this.itemdata = {
							"filehash": "",
							"filelocation": "",
							"filename": "",
							"filesize": "",
							"filetype": ""
						}
						this.fileName = ''
						this.$nextTick(() => {
							if (data.videos) {
								this.itemdata = { ...data.videos[0] }
								this.fileName = data.videos[0].filename
								this.videoBase64 = this.spliceUrl(data.videos[0].filelocation)
								this.videoFileList = [{url: this.videoBase64, name: this.fileName}]
							}
						})
					})
				e.preventDefault()
			},
			uploadImage(e) {
        if (e.target.className !== 'el-upload__input') return
				callApp('getImage', {
					type: 'dataSource.file.image',
					data: {
						max: this.item.max,
            type: this.item.acceptedFileType || []
          }
				}, 'cbGetImage')
					.then(data => {
						this.imgFileList = []
						this.itemdata = {
							"filehash": "",
							"filelocation": "",
							"filename": "",
							"filesize": "",
							"filetype": ""
						}
						this.$nextTick(() => {
							 if (data.images) {
								 this.itemdata = { ...data.images[0] }
								 this.fileName = data.images[0].filename
								 this.imageBase64 = this.spliceUrl(data.images[0].filelocation)
								 this.imgFileList = [{url: this.imageBase64, name: this.fileName}]
							 }
						})
					})
        e.preventDefault()
			}
		},
		computed: {
			...mapGetters({
				formStatus: 'getFormStatus',
				softDataStatus: 'getSoftDataStatus'
			}),
			itemdata: {
				get() {
					if (this.formStatus !== 'init') {
						if (this.item.contentType === 'media/file' ) {
							this.fileName = this.value.filename
							this.fileName && (this.fileList = [{url: this.spliceUrl(this.value.filelocation), name: this.fileName}])
						}
						if (this.item.contentType === 'media/image') {
							this.fileName = this.value.filename
							this.imageBase64 = this.spliceUrl(this.value.filelocation)
							this.fileName && (this.imgFileList = [{url: this.imageBase64, name: this.fileName}])
						}

						if (this.item.contentType.toLowerCase() === 'media/video') {
							this.fileName = this.value.filename
							this.videoBase64 = this.spliceUrl(this.value.filelocation)
							this.fileName && (this.videoFileList = [{url: this.videoBase64, name: this.fileName}])
						}
          }
					return this.value
        },
				set(itemdata) { 
					this.$emit('input', itemdata) 
					}
			}
		}
	}
</script>

<style lang="stylus">
  .ve-file-close
    position absolute
    z-index 1
    top -16px
    left -4px
    font-size 20px
  .hiddenUpload
    .el-upload
      display  none !important
  .ve-upload
    .el-form-item__content
      text-align center
  .ve-upload-icon
    width 62px
    position relative
    margin-top 40px
  .pdf-file
    .el-upload
      display block
  .el-upload__text em
    color #9B9B9B !important
    font-weight 500
  .el-upload-list--picture-card
    display flex
    justify-content center
    .el-upload-list__item
      width 100%
      height auto
      margin-right 0
  .el-upload--picture-card
    display flex
    flex-direction column
    width 100%
    img
      align-self center
    .el-upload__text
      line-height 48px
</style>
